/**
 * Employee profile domain entity.
 * Represents the profile details shown in the Employee 360 View.
 */
export class EmployeeProfileEntity {
  public userId!: string;
  public firstName!: string;
  public lastName!: string;
  public email!: string;
  public phone!: string;
  public position!: string;
  public department!: string;
  public isActive!: boolean;

  /**
   * Full name derived from first and last name.
   */
  public get fullName(): string {
    return `${this.firstName} ${this.lastName}`.trim();
  }
}
